let mainPath = "/receivingreports";
let viewFolder = "ReceivingReport";

module.exports = [
    {
        path: mainPath+'/view/:id',
        name: 'receivingReport',
        component: () => import('../views/'+viewFolder+'/View.vue'),
    }
]